module.exports = __webpack_public_path__ + "distribution/img/x2.c6cbd4b2.png";